<ng-template #loadingSimulation>
    <div class="d-flex flex-column h-100">
        <ng-container *ngIf="contract.HasContaCerta">
            <ng-container *ngIf="!this.successUploadReading">
                <edp-loader [size]="'md'" class="text-center my-4"></edp-loader>
                <span class="simulation-load-message text-center">
                    {{ "pt.edp.edponline.dashboard.widget.consumptions.simulation.loadingSent" | translate }}
                </span>
            </ng-container>
            <ng-container *ngIf="this.successUploadReading">
                <div class="d-flex flex-column align-items-center simulation-success-message success-reading my-4">
                    <span class="mb-2">
                        <i class="icon icon-edponline-Bop-072"  aria-hidden="true"></i>
                    </span>
                    <span class="success-reading-message">
                        {{  (offlineReading ?
                            "pt.edp.edponline.dashboard.widget.consumptions.simulation.offlineReadingRegistered" :
                            "pt.edp.edponline.dashboard.widget.consumptions.simulation.successUploadReading") | translate }}
                    </span>
                </div>
                <div *ngIf="!offlineReading" class="simulation-alert simulation-load">
                    <edp-loader [size]="'sm'" class="text-center mr-3"></edp-loader>
                    <span class="simulation-load-message">{{ 'pt.edp.edponline.readings.conta.certa.loading' | translate }}</span>                    
                </div>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-container *ngIf="activeTabActiveMeters && contract.HasContaCerta && simulation$ | async as simulation; else loadingSimulation">
    <div class="d-flex flex-column h-100" *ngIf="simulation.simulationValue">
        <ng-container #headingBlock [ngSwitch]="this.contract.getType()">
            <ng-container *ngSwitchCase="'dual'">
                <ng-container *ngIf="!hiddenTabActiveMetersSubmitted">
                    <span class="simulation-title" *ngIf="activeTab === 'E'"
                        [innerHTML]="'pt.edp.edponline.readings.conta.certa.title.gas' | translate ">
                    </span>
                    <span class="simulation-title" *ngIf="activeTab === 'G'"
                        [innerHTML]="'pt.edp.edponline.readings.conta.certa.title.eletricidade' | translate ">
                    </span>
                </ng-container>

                <ng-container *ngIf="hiddenTabActiveMetersSubmitted">
                    <span class="simulation-title">
                        <b>
                            <span>{{ labelToPayOrRecieve | translate }}</span>
                        </b>
                        {{ 'pt.edp.edponline.readings.conta.certa.dual.sent.title' | translate }}
                    </span>
                    <span class="simulation-description">
                        {{ "ContractReadings.Eletricidade" | translate }} e {{ "ContractReadings.Gas" | translate }}
                    </span>
                </ng-container>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <span class="simulation-title">
                    <b>
                        <span>{{ labelToPayOrRecieve | translate }}</span>
                    </b>
                    {{ 'pt.edp.edponline.readings.conta.certa.dual.sent.title' | translate }}
                </span>
                <span *ngIf="activeTab === 'E'" class="simulation-description">{{ "ContractReadings.Eletricidade" | translate }}</span>
                <span *ngIf="activeTab === 'G'" class="simulation-description">{{ "ContractReadings.Gas" | translate }}</span>
            </ng-container>
        </ng-container>
        <ng-container #supplyIconBlock [ngSwitch]="this.contract.getType()">
            <ng-container *ngSwitchCase="'dual'">
                <div class="d-flex justify-content-between my-3" *ngIf="simulation.simulationValue && hiddenTabActiveMetersSubmitted && valueContaCertaAcertoFinal">
                        <div class="d-flex flex-column">
                            <span class="simulation-value" [innerHTML]="valueContaCertaAcertoFinal | edpDecimalSplit"></span>
                            <span class="simulation-value-description"
                                [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.taxas' | translate">
                            </span>
                        </div>
                    <span class="icon-type my-auto">
                        <i class="icon {{ type.iconBra }}"  aria-hidden="true"></i>
                    </span>
                </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <div class="d-flex justify-content-between my-3" *ngIf="simulation.simulationValue && valueContaCertaAcertoFinal">
                    <div class="d-flex flex-column">
                        <span class="simulation-value" [innerHTML]="valueContaCertaAcertoFinal | edpDecimalSplit"></span>
                        <span class="simulation-value-description"
                            [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.taxas' | translate">
                        </span>
                    </div>
                    <span class="icon-type my-auto">
                        <i *ngIf="activeTab === 'E'" class="icon {{ this.contract.getTypeProperties('electricity').iconBra }}"  aria-hidden="true"></i>
                        <i *ngIf="activeTab === 'G'" class="icon {{ this.contract.getTypeProperties('gas').iconBra }}"  aria-hidden="true"></i>
                    </span>
                </div>
            </ng-container>
        </ng-container>
        <ng-container #contentBlock [ngSwitch]="this.contract.getType()">
            <div class="d-flex mb-3">
                <ng-container *ngSwitchCase="'dual'">
                    <ng-container *ngIf="!hiddenTabActiveMetersSubmitted">
                        <div class="d-flex justify-content-between mt-5 w-100">
                            <div class="d-flex flex-column">
                                <span *ngIf="activeTab === 'E'" class="simulation-type mr-2">{{ "ContractReadings.Eletricidade" | translate }}</span>
                                <span *ngIf="activeTab === 'G'" class="simulation-type mr-2">{{ "ContractReadings.Gas" | translate }}</span>
                                <span class="simulation-description font-weight-bold"
                                    *ngIf="activeTabActiveMeters.simulation?.realDays
                                    &&
                                    activeTabActiveMeters.simulation?.estimatedDays">
                                    <b>
                                        {{'pt.edp.edponline.dashboard.widget.consumptions.simulation.realAndEstimatedDays'
                                        |
                                        translate:{'realDays':
                                        activeTabActiveMeters.simulation?.realDays,
                                        'estimatedDays':
                                        activeTabActiveMeters.simulation?.estimatedDays
                                        } }}
                                    </b>
                                </span>
                                <span class="d-block simulation-description font-weight-bold"
                                    *ngIf="activeTabActiveMeters.updateReadingOutTime">
                                    {{'pt.edp.edponline.dashboard.widget.consumptions.outSideTime'
                                    | translate}}</span>
                                <span class="d-block simulation-description font-weight-bold"
                                    *ngIf="activeTabActiveMeters.updateReadingInTime">
                                    {{'pt.edp.edponline.dashboard.widget.consumptions.inSideTime'
                                    | translate}}</span>
                            </div>
                            <div class="d-flex flex-column">
                                <span class="icon-dual ml-auto">
                                    <i *ngIf="activeTab === 'E'" class="icon {{ this.contract.getTypeProperties('electricity').iconBra }}"  aria-hidden="true"></i>
                                    <i *ngIf="activeTab === 'G'" class="icon {{ this.contract.getTypeProperties('gas').iconBra }}"  aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="hiddenTabActiveMetersSubmitted">
                        <div class="d-flex flex-column w-50">
                            <span class="simulation-type mr-2">{{
                                'ContractReadings.Eletricidade'
                                | translate }}
                            </span>
                            <ng-container
                                *ngIf="activeTab === 'E'">
                                <span class="d-block simulation-description padding-description font-weight-bold"
                                    *ngIf="activeTabActiveMeters.simulation?.realDays &&
                                    activeTabActiveMeters.simulation?.estimatedDays">
                                    {{'pt.edp.edponline.dashboard.widget.consumptions.simulation.realAndEstimatedDays'
                                    |
                                    translate:{'realDays':
                                    activeTabActiveMeters.simulation?.realDays,
                                    'estimatedDays':
                                    activeTabActiveMeters.simulation?.estimatedDays
                                    } }}
                                </span>
                            </ng-container>
                            <ng-container
                                *ngIf="activeTab === 'G'">
                                <span class="d-block simulation-description padding-description font-weight-bold"
                                    *ngIf="hiddenTabActiveMetersSubmitted.simulation?.realDays &&
                                    hiddenTabActiveMetersSubmitted.simulation?.estimatedDays">
                                    {{'pt.edp.edponline.dashboard.widget.consumptions.simulation.realAndEstimatedDays'
                                    |
                                    translate:{'realDays':
                                    hiddenTabActiveMetersSubmitted.simulation?.realDays,
                                    'estimatedDays':
                                    hiddenTabActiveMetersSubmitted.simulation?.estimatedDays
                                    } }}
                                </span>
                            </ng-container>
                        </div>
                        <div class="d-flex flex-column w-50">
                            <span class="simulation-type mr-2">{{
                                'ContractReadings.Gas'
                                | translate }}</span>
                            <ng-container
                                *ngIf="activeTab ===
                                'E'">
                                <span class="d-block simulation-description padding-description font-weight-bold"
                                    *ngIf="hiddenTabActiveMetersSubmitted.simulation?.realDays &&
                                    hiddenTabActiveMetersSubmitted.simulation?.estimatedDays">
                                    {{'pt.edp.edponline.dashboard.widget.consumptions.simulation.realAndEstimatedDays'
                                    |
                                    translate:{'realDays':
                                    hiddenTabActiveMetersSubmitted.simulation?.realDays,
                                    'estimatedDays':
                                    hiddenTabActiveMetersSubmitted.simulation?.estimatedDays
                                    } }}
                                </span>
                            </ng-container>
                            <ng-container
                                *ngIf="activeTab ===
                                'G'">
                                <span class="d-block simulation-description padding-description font-weight-bold"
                                    *ngIf="activeTabActiveMeters.simulation?.realDays &&
                                    activeTabActiveMeters.simulation?.estimatedDays">
                                    {{'pt.edp.edponline.dashboard.widget.consumptions.simulation.realAndEstimatedDays'
                                    |
                                    translate:{'realDays':
                                    activeTabActiveMeters.simulation?.realDays,
                                    'estimatedDays':
                                    activeTabActiveMeters.simulation?.estimatedDays
                                    } }}
                                </span>
                            </ng-container>
                        </div>
                    </ng-container>

                </ng-container>
                <ng-container *ngSwitchDefault>
                    <div class="d-flex flex-column">
                        <span *ngIf="activeTab === 'E'" class="simulation-type mr-2">{{ "ContractReadings.Eletricidade" | translate }}</span>
                        <span *ngIf="activeTab === 'G'" class="simulation-type mr-2">{{ "ContractReadings.Gas" | translate }}</span>
                        <span class="d-block simulation-description font-weight-bold"
                            *ngIf="activeTabActiveMeters.simulation?.realDays &&
                            activeTabActiveMeters.simulation?.estimatedDays">
                            {{'pt.edp.edponline.dashboard.widget.consumptions.simulation.realAndEstimatedDays'
                            |
                            translate:{'realDays':
                            activeTabActiveMeters.simulation?.realDays,
                            'estimatedDays':
                            activeTabActiveMeters.simulation?.estimatedDays
                            } }}
                        </span>
                    </div>
                </ng-container>
            </div>
        </ng-container>
        <ng-container #footerBlock [ngSwitch]="this.contract.getType()">
            <ng-container *ngSwitchCase="'dual'">
                <ng-container *ngIf="!hiddenTabActiveMetersSubmitted">
                    <div class="simulation-alert simulation-success">
                        <div class="d-flex justify-content-between my-2 w-100">
                            <span>{{ "pt.edp.edponline.dashboard.widget.consumptions.simulation.successUploadReading" | translate }}</span>
                            <span>
                                <i class="icon icon-edponline-Bop-072"  aria-hidden="true"></i>
                            </span>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="hiddenTabActiveMetersSubmitted">
                    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
                </ng-container>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
            </ng-container>
        </ng-container>
    </div>
</ng-container>

<ng-template #footerTemplate>
    <div class="simulation-alert" [ngClass]="contaCertaPercentage > -0.3 && contaCertaPercentage < 0.2  ? 'simulation-success' : 'simulation-warning'">
        <div class="d-flex justify-content-between w-100" *ngIf="contaCertaPercentage > -0.3 && contaCertaPercentage < 0.2">
            <span>
                {{ 'pt.edp.edponline.readings.conta.certa.toast.ajusted' | translate }}
            </span>
            <span class="ml-3 my-auto">
                <i class="icon icon-edponline-Bop-072"  aria-hidden="true"></i>
            </span>
        </div>
        <div class="d-flex justify-content-between w-100" *ngIf="contaCertaPercentage > 0.2">
            <span>
                {{ 'pt.edp.edponline.readings.conta.certa.toast.lower' | translate }}
            </span>
            <span class="ml-3 my-auto">
                <i class="icon icon-edponline-Bop-025"  aria-hidden="true"></i>
            </span>
        </div>
        <div class="d-flex justify-content-between w-100" *ngIf="contaCertaPercentage < -0.3">
            <span>
                {{ 'pt.edp.edponline.readings.conta.certa.toast.higher' | translate }}
            </span>
            <span class="ml-3 my-auto">
                <i class="icon icon-edponline-Bop-025"  aria-hidden="true"></i>
            </span>
        </div>
    </div>
</ng-template>
